export const toModel = (model, data) => {
  const result = {};

  if (!data) {
    return result;
  }

  Object.keys(data).forEach((field) => {
    if (field in model) {
      result[field] = data[field];
    }
  });

  return result;
};
